import api, {
  buildQueryParams,
  IEnhancedCursorPaginatedResponse,
  IGetQueryParams,
} from '../index';
import { INotification } from './types';

export const notificationsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getNotificationsCounter: builder.query<
      { unread_messages_count: number; unread_notifications_count: number },
      void
    >({
      query: (params) => `/notifications/counters`,
      providesTags: [{ type: 'NotificationsCounter' }],
    }),

    getNotifications: builder.query<
      IEnhancedCursorPaginatedResponse<INotification>,
      IGetQueryParams<{}>
    >({
      query: (params) => `/notifications${buildQueryParams(params)}`,
      providesTags: [{ type: 'Notifications' }],
    }),

    markAllNotificationsAsRead: builder.mutation<void, void>({
      query: (body) => {
        return {
          url: `/notifications/mark_all_as_read`,
          method: 'PUT',
        };
      },
      invalidatesTags: [{ type: 'NotificationsCounter' }],
    }),

    markNotificationAsRead: builder.mutation<INotification, number>({
      query: (notificationId) => {
        return {
          url: `/notifications/mark_as_read/${notificationId}`,
          method: 'PUT',
        };
      },
      transformResponse: ({ notification }: { notification: INotification }) =>
        notification,
      invalidatesTags: [{ type: 'NotificationsCounter' }],
    }),

    resetNotificationCounter: builder.mutation<void, void>({
      query: () => {
        return {
          url: `/notifications/reset_counter`,
          method: 'PUT',
        };
      },
      invalidatesTags: [{ type: 'NotificationsCounter' }],
    }),
  }),
});

export const {
  useGetNotificationsQuery,
  useLazyGetNotificationsQuery,
  useGetNotificationsCounterQuery,
  useMarkNotificationAsReadMutation,
  useResetNotificationCounterMutation,
  useMarkAllNotificationsAsReadMutation,
} = notificationsApi;
